const DAYS_IN_WEEK = 7;

const HOURS_IN_DAY = 24;
const MAX_HOURS = HOURS_IN_DAY * DAYS_IN_WEEK;

const generateHoursArray = () => {
  const regularHours = [...new Array(HOURS_IN_DAY).keys()];
  const additionalHours = [];

  for (let hour = HOURS_IN_DAY + 23; hour < MAX_HOURS; hour += HOURS_IN_DAY) {
    additionalHours.push(hour);
  }

  return [...regularHours, ...additionalHours];
};

export const SHORTED_HOURS = [...new Array(HOURS_IN_DAY).keys()];
export const HOURS_ARRAY = generateHoursArray();
export const MINUTES_ARRAY = [...new Array(60).keys()];
export const DAYS_ARRAY = [...new Array(100).keys()];
